import { render, staticRenderFns } from "./donut-chart.component.vue?vue&type=template&id=71660e66&scoped=true"
import script from "./donut-chart.component.ts?vue&type=script&lang=ts&external"
export * from "./donut-chart.component.ts?vue&type=script&lang=ts&external"
import style0 from "./donut-chart.component.vue?vue&type=style&index=0&id=71660e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71660e66",
  null
  
)

export default component.exports